import maybeFormatMessage from './maybeFormatMessage';

export default function maybeFormatPrefixedMessage(
  intl,
  keyPrefix,
  formatMessage = maybeFormatMessage,
) {
  return keySuffix => formatMessage(intl, keyPrefix, keySuffix);
}
